import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import {
  Card, CardHeader, CardTitle, HeaderActions, Skeleton, State,
} from '../styles';

// Spec §6.5 — panel çerçevesi: başlık + sağ işlemler; iskelet, boş durum (seçim açıklamasıyla), hata + "Tekrar Dene";
// grafikli panellerde "Tablo olarak göster" geçişi (erişilebilirlik). Bir panelin durumu diğerlerini etkilemez.
export default function PanelCard({
  panelKey, title, span, kpi, compact, loading, error, onRetry, empty, emptyText, actions, tableToggle, showTable, onToggleTable, children,
}) {
  const { t } = useTranslation();
  let body = children;
  if (loading) body = <Skeleton data-state="loading" />;
  else if (error) {
    body = (
      <State data-state="error">
        <span>{t('performance.operations.panel.error')}</span>
        <Button variant="outline" onClick={onRetry} data-action="retry">{t('performance.operations.panel.retry')}</Button>
      </State>
    );
  } else if (empty) body = <State data-state="empty">{emptyText || t('performance.operations.panel.empty')}</State>;

  return (
    <Card $span={span} $kpi={kpi} $compact={compact} data-panel={panelKey} aria-busy={loading ? 'true' : 'false'}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <HeaderActions>
          {tableToggle && !loading && !error && !empty ? (
            <Button variant="ghost" onClick={onToggleTable} data-action="toggle-table">
              {showTable ? t('performance.operations.panel.showChart') : t('performance.operations.panel.showTable')}
            </Button>
          ) : null}
          {actions}
        </HeaderActions>
      </CardHeader>
      {body}
    </Card>
  );
}
